import styled from 'styled-components';
import { screenSm } from 'constants/styles/breakpoints';
import {
  GroupContent,
  GroupContentTagWrapper,
  GroupTitle,
  LearningPathDetailContainer,
} from '../LearningPath/styles';

// Spacing mirrors the collection breakdown in the Assigned users section
// (UsersTable LearningPathTopicContainer / GroupTitleLearningPath / ContentList).
export const CollectionDetailContainer = styled(LearningPathDetailContainer)`
  padding: 10px 20px;

  ${screenSm} {
    padding: 10px 30px 10px 20px;
  }
`;

export const CollectionLabsTitle = styled(GroupTitle)`
  font-weight: 450;
  line-height: 24px;
  margin-bottom: 10px;
`;

export const CollectionLabsList = styled(GroupContent)`
  margin-top: 20px;
`;

// Icon-only tags are narrow, so the learning path min-width would leave a gap.
export const CollectionLabTagWrapper = styled(GroupContentTagWrapper)`
  min-width: unset;
`;
